export const Months = [
    "Baishak", "Jestha", "Asar", "Shrawan", "Bhadra",
    "Ashoj", "Kartik", "Mangsir", "Poush", "Magh", "Falgun", "Chaitra"
];

export const getNepaliMonthIndex = (month: string) => Months.indexOf(month);

export function sortByNepaliDate(
    a: { year: number | null, month: string | null, day: number | null },
    b: { year: number | null, month: string | null, day: number | null }
) {
    // comparing by year (with null check)
    if (a.year !== b.year) {
        if (a.year === null) return -1;
        if (b.year === null) return 1;
        return a.year - b.year;
    }

    // If years are equal, compare by Nepali month
    const monthIndexA = getNepaliMonthIndex(a.month || "");
    const monthIndexB = getNepaliMonthIndex(b.month || "");

    if (monthIndexA !== monthIndexB) {
        return monthIndexA - monthIndexB;
    }

    // If months are equal, compare by day (with null check)
    if (a.day === null) return -1;
    if (b.day === null) return 1;
    return (a.day || 0) - (b.day || 0);
}
